<template>
  <div v-if="schedule_group" class="job-week h-min-200">
    <div class="row">
      <JobDayHeader
        v-for="index in Number(schedule_group.days)"
        v-bind:key="index"
        class="col"
        :day_index="index - 1"
      />
    </div>
    <div class="row">
      <div
        v-for="index in Number(schedule_group.days)"
        v-bind:key="index - 1"
        class="col"
      >
        <CombinedJobDayDisplay :day_index="index - 1" />
      </div>
    </div>
  </div>
</template>

<script>
import CombinedJobDayDisplay from "@/components/job/CombinedJobDayDisplay.vue";
import JobDayHeader from "@/components/job/JobDayHeader.vue";
import { mapState } from "vuex";

export default {
  name: "CombinedJobWeekDisplay",
  data: () => ({
    loading: true,
    dragging_enabled: false,
    week_index: 0,
  }),
  mounted() {
    this.$nextTick(() => {});
  },
  computed: {
    ...mapState("schedule", ["schedule_group"]),
  },
  methods: {
    toggle_dragging() {
      this.dragging_enabled = !this.dragging_enabled;
    },
  },
  components: {
    JobDayHeader,
    CombinedJobDayDisplay,
  },
};
</script>
